/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from "react";
import "./index.scss";
import { Button} from "@mui/material";


export default function CouponTitle(props:any) {
  const [selected, setSelected] = useState<string>("available");
  const handleTabChange = (tab: string) => {
    console.log('子组件中tab====',tab)
    setSelected(tab);
    props.refresh(tab)
  };
  useEffect(() => {}, []);

  return (
      <div className="applay-title">
        <h1 className="applay-title-text">Coupons</h1>
        <div className="applay-title-tab-box">
          <Button
            size="large"
            className={`tab-style tab-left ${selected === "available" ? "selected" : 'unselected'}`}
            onClick={() => handleTabChange("available")}
          >
            Available
          </Button>
          <Button
            size="large"
            className={`tab-style tab-right ${selected !== "available" ? "selected" : 'unselected'}`}
            onClick={() => handleTabChange("notavailable")}
          >
            Coupon history
          </Button>
        </div>
      </div>
  );
}
